var _excluded = ["items", "currentItem"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import getColor from "../../../utils/getColor";
import getTextColor from "../../../utils/getTextColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import TextAtm from "../../atoms/TextAtm";
import { cssTextAtm } from "../../atoms/TextAtm/TextAtm.styled";
import Link from "../../quarks/Link";
var typography = "nano2";
var activeColor = "secondary";
var itemVerticalGutterSpace = 0.5;
var itemHorizontalGutterSpace = 1;
var Container = styled.ol.withConfig({
  componentId: "sc-8m8ysx-0"
})(function (_ref) {
  var $onColor = _ref.$onColor;
  return css(["display:flex;position:relative;flex-wrap:wrap;align-items:center;margin-bottom:", ";margin-left:", ";li{display:flex;margin-bottom:", ";margin-left:", ";&::after{", ";content:\"/\";margin-left:", ";}&:last-child{&::after{display:none;}}> *{white-space:nowrap;}}"], unit(-1 * itemVerticalGutterSpace), space(-1 * itemHorizontalGutterSpace), unit(itemVerticalGutterSpace), space(itemHorizontalGutterSpace), cssTextAtm({
    typography: typography,
    onColor: $onColor
  }), space(itemHorizontalGutterSpace));
});
var Item = styled(Link).withConfig({
  componentId: "sc-8m8ysx-1"
})(function (_ref2) {
  var $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["", ";", ";color:", ";text-decoration:none;&:hover{color:", ";}"], transition("color"), cssTextAtm({
    typography: typography,
    onColor: $onColor
  }), getTextColor(theme, $onColor, "medium"), getColor(theme, activeColor));
});
function BreadcrumbsMol(_ref3) {
  var items = _ref3.items,
    currentItem = _ref3.currentItem,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(Container, _extends({
    $onColor: onColor
  }, restProps), items.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.text
    }, /*#__PURE__*/React.createElement(Item, {
      to: item.to,
      href: item.href,
      title: item.title,
      onClick: item.onClick,
      $onColor: onColor
    }, item.text));
  }), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(TextAtm, {
    typography: typography,
    color: activeColor
  }, currentItem)));
}
export default BreadcrumbsMol;